import rtbhouse from "web/script/embedded/rtb-house";
import environment from "web/script/modules/environment";

// `TAGGING_HASHES` keys for the SDK init call.
const TAGGING_HASHES = {
    GB: "hw8YkNOaHWTbWeZ0sU3O",
    US: "RTeo1OPwTx0VKkrQcm3o",
};
const DATA_CENTRES = {
    GB: "",
    US: "us",
};
const SUPPORTED_COUNTRIES = new Set(Object.keys(TAGGING_HASHES));
const VALID_PAGETYPES = new Set(["homepage", "feed", "search", "product", "product_overlay"]);

let cachedAnalytics = null;
let initialized = false;

function resolveUserId() {
    return cachedAnalytics.getDeviceUid() || "unknown";
}

function pushInit(country) {
    if (initialized) return;
    // RTB House requires the hash as both the SDK positional arg and the init payload `value` field.
    rtbhouse(TAGGING_HASHES[country], {
        eventType: "init",
        value: TAGGING_HASHES[country],
        dc: DATA_CENTRES[country],
    });
    initialized = true;
}

function mapLeadConversion(d) {
    const out = {
        eventType: "conversion",
        conversionClass: "action",
        conversionSubClass: "clickthrough",
        conversionId: d._uuid,
        conversionValue: d.customData?.sale_price,
        offerIds: [d.customData?.product_id],
    };
    if (d.customData?.currency) out.conversionCurrency = d.customData.currency;
    return out;
}

function mapFeedProductIds(d) {
    const pageType = environment.get("pageType");
    const pva = environment.get("pageViewAnalytics") || {};
    const offerIds = (d.customData?.ids || []).slice(0, 5);

    if (pageType === "feed" && pva.feed_category)
        return { eventType: "category", categoryName: pva.feed_category };
    if (pageType === "feed" || pageType === "search") return { eventType: "listing", offerIds };
    return null;
}

function mapEvent(evt) {
    const d = evt.data || {};
    // Homepage and unknown page types are handled at page_view level.
    // feed/search page_views produce no tag — the listing/category tag fires
    // from the feed_product_ids event once the grid has rendered with product IDs.
    if (evt.type === "page_view") {
        if (!VALID_PAGETYPES.has(d.page_type)) return { eventType: "placebo" };
        if (d.page_type === "homepage") return { eventType: "home" };
        if (d.page_type === "product" || d.page_type === "product_overlay") {
            return { eventType: "offer", offerId: d.product_id };
        }
    }

    // Feeds and wishlist are handled at event level
    if (evt.type === "event") {
        if (d.category === "feed" && d.action === "view" && d.label === "feed_product_ids") {
            return mapFeedProductIds(d);
        }
        if ((d.action === "lead" || d.action === "lead_sold_out") && !d.customData?.isCssLead) {
            return mapLeadConversion(d);
        }
        if (d.category === "save_for_later" && d.action === "add_item") {
            return { eventType: "wishlist", offerId: d.customData?.product_id };
        }
    }

    // All other events are ignored
    return null;
}

export default {
    init(analytics) {
        cachedAnalytics = analytics;
        initialized = false; // re-initialize across consent changes / test runs
    },
    async send(data) {
        const country = environment.get("country");
        if (!SUPPORTED_COUNTRIES.has(country)) return;

        const tags = data.map(mapEvent).filter(Boolean);
        if (!tags.length) {
            return;
        }

        pushInit(country);
        const uid = await resolveUserId();
        tags.forEach((tag) => {
            rtbhouse(TAGGING_HASHES[country], tag, { eventType: "uid", id: uid });
        });
    },
};
